var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPersonalize(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 49,
    height: 49,
    fill: "#F5F5F5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Product",
    clipPath: "url(#clip0_8011_14434)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 5148,
    transform: "translate(-253 -1451)",
    fill: "#141414"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Frame 53040"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 53041"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 53037",
    filter: "url(#filter0_bd_8011_14434)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -55.5,
    y: -47.7676,
    width: 750,
    height: 318,
    rx: 16,
    fill: "url(#paint0_linear_8011_14434)",
    fillOpacity: 0.15,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -55,
    y: -47.2676,
    width: 749,
    height: 317,
    rx: 15.5,
    stroke: "url(#paint1_linear_8011_14434)",
    strokeOpacity: 0.3,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("g", {
    id: "digital-design-DC86F5KA3G 1",
    clipPath: "url(#clip1_8011_14434)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Digital Design"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M31.5 38.2324H17.5C17.2348 38.2324 16.9804 38.1271 16.7929 37.9395C16.6054 37.752 16.5 37.4976 16.5 37.2324C16.5 36.9672 16.6054 36.7129 16.7929 36.5253C16.9804 36.3378 17.2348 36.2324 17.5 36.2324H31.5C31.7652 36.2324 32.0196 36.3378 32.2071 36.5253C32.3946 36.7129 32.5 36.9672 32.5 37.2324C32.5 37.4976 32.3946 37.752 32.2071 37.9395C32.0196 38.1271 31.7652 38.2324 31.5 38.2324Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M31.5 38.2324H17.5C17.2348 38.2324 16.9804 38.1271 16.7929 37.9395C16.6054 37.752 16.5 37.4976 16.5 37.2324C16.5 36.9672 16.6054 36.7129 16.7929 36.5253C16.9804 36.3378 17.2348 36.2324 17.5 36.2324H31.5C31.7652 36.2324 32.0196 36.3378 32.2071 36.5253C32.3946 36.7129 32.5 36.9672 32.5 37.2324C32.5 37.4976 32.3946 37.752 32.2071 37.9395C32.0196 38.1271 31.7652 38.2324 31.5 38.2324Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M22.5 2.23242H5.5C5.23478 2.23242 4.98043 2.33778 4.79289 2.52532C4.60536 2.71285 4.5 2.96721 4.5 3.23242C4.5 3.49764 4.60536 3.75199 4.79289 3.93953C4.98043 4.12707 5.23478 4.23242 5.5 4.23242H14.12C12.1687 5.35334 10.4971 6.90222 9.23097 8.7625C7.9648 10.6228 7.13705 12.746 6.81 14.9724L6.5 17.0924C6.48161 17.2237 6.48928 17.3574 6.52254 17.4858C6.55581 17.6141 6.61404 17.7347 6.6939 17.8405C6.85518 18.0543 7.09478 18.1953 7.36 18.2324C7.62522 18.2696 7.89432 18.1998 8.10811 18.0385C8.3219 17.8772 8.46287 17.6376 8.5 17.3724L8.79 15.2324C9.24415 12.1825 10.7758 9.39605 13.1074 7.37812C15.4391 5.36018 18.4164 4.24421 21.5 4.23242H22.5C22.7652 4.23242 23.0196 4.12707 23.2071 3.93953C23.3946 3.75199 23.5 3.49764 23.5 3.23242C23.5 2.96721 23.3946 2.71285 23.2071 2.52532C23.0196 2.33778 22.7652 2.23242 22.5 2.23242Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M0.5 0.232422H6.5V6.23242H0.5V0.232422Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M43.5 2.23242H26.5C26.2348 2.23242 25.9804 2.33778 25.7929 2.52532C25.6054 2.71285 25.5 2.96721 25.5 3.23242C25.5 3.49764 25.6054 3.75199 25.7929 3.93953C25.9804 4.12707 26.2348 4.23242 26.5 4.23242H27.5C30.5836 4.24421 33.5609 5.36018 35.8926 7.37812C38.2242 9.39605 39.7558 12.1825 40.21 15.2324L40.51 17.3524C40.5284 17.4837 40.5725 17.6102 40.6397 17.7244C40.7069 17.8387 40.796 17.9387 40.9019 18.0185C41.0077 18.0984 41.1283 18.1566 41.2567 18.1899C41.385 18.2231 41.5187 18.2308 41.65 18.2124C41.7813 18.194 41.9077 18.15 42.022 18.0827C42.1363 18.0155 42.2362 17.9264 42.3161 17.8205C42.396 17.7147 42.4542 17.5941 42.4875 17.4658C42.5207 17.3374 42.5284 17.2037 42.51 17.0724L42.21 14.9524C41.8779 12.7278 41.0458 10.6073 39.7762 8.75058C38.5066 6.89382 36.8326 5.34905 34.88 4.23242H43.5C43.7652 4.23242 44.0196 4.12707 44.2071 3.93953C44.3946 3.75199 44.5 3.49764 44.5 3.23242C44.5 2.96721 44.3946 2.71285 44.2071 2.52532C44.0196 2.33778 43.7652 2.23242 43.5 2.23242Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M48.5 6.23242L42.5 6.23242V0.232422L48.5 0.232422V6.23242Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M24.5 6.23242C26.1569 6.23242 27.5 4.88928 27.5 3.23242C27.5 1.57557 26.1569 0.232422 24.5 0.232422C22.8431 0.232422 21.5 1.57557 21.5 3.23242C21.5 4.88928 22.8431 6.23242 24.5 6.23242Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M7.5 23.2324C9.15685 23.2324 10.5 21.8893 10.5 20.2324C10.5 18.5756 9.15685 17.2324 7.5 17.2324C5.84315 17.2324 4.5 18.5756 4.5 20.2324C4.5 21.8893 5.84315 23.2324 7.5 23.2324Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M25.5 24.4124C25.5 9.56244 25.57 11.1624 25.32 10.6524C25.227 10.5218 25.104 10.4155 24.9613 10.3424C24.8185 10.2693 24.6603 10.2316 24.5 10.2324C24.2348 10.2324 23.9804 10.3378 23.7929 10.5253C23.6054 10.7129 23.5 10.9672 23.5 11.2324V24.4124C22.8328 24.6483 22.2705 25.1125 21.9124 25.7229C21.5543 26.3333 21.4235 27.0507 21.5432 27.7482C21.6629 28.4457 22.0253 29.0784 22.5663 29.5345C23.1074 29.9907 23.7923 30.2409 24.5 30.2409C25.2077 30.2409 25.8926 29.9907 26.4337 29.5345C26.9747 29.0784 27.3371 28.4457 27.4568 27.7482C27.5765 27.0507 27.4457 26.3333 27.0876 25.7229C26.7296 25.1125 26.1672 24.6483 25.5 24.4124Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M41.5 23.2324C43.1569 23.2324 44.5 21.8893 44.5 20.2324C44.5 18.5756 43.1569 17.2324 41.5 17.2324C39.8431 17.2324 38.5 18.5756 38.5 20.2324C38.5 21.8893 39.8431 23.2324 41.5 23.2324Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M15.5 41.2324H33.5V47.2324H15.5V41.2324Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M37.2712 28.8726C37.4058 28.6978 37.4788 28.4833 37.4788 28.2626C37.4788 28.042 37.4058 27.8275 37.2712 27.6526L25.2712 10.6526C25.1793 10.5186 25.0562 10.4089 24.9125 10.3331C24.7687 10.2574 24.6087 10.2178 24.4462 10.2178C24.2837 10.2178 24.1236 10.2574 23.9799 10.3331C23.8361 10.4089 23.713 10.5186 23.6212 10.6526C23.5712 10.7526 23.9212 10.2326 11.6212 27.6526C11.4936 27.833 11.4293 28.0505 11.4383 28.2712C11.4474 28.4919 11.5293 28.7034 11.6712 28.8726L16.5012 34.5926V40.2326H15.5012C15.2359 40.2326 14.9816 40.338 14.7941 40.5255C14.6065 40.7131 14.5012 40.9674 14.5012 41.2326V47.2326C14.5012 47.4979 14.6065 47.7522 14.7941 47.9397C14.9816 48.1273 15.2359 48.2326 15.5012 48.2326H33.5012C33.7664 48.2326 34.0207 48.1273 34.2083 47.9397C34.3958 47.7522 34.5012 47.4979 34.5012 47.2326V41.2326C34.5012 40.9674 34.3958 40.7131 34.2083 40.5255C34.0207 40.338 33.7664 40.2326 33.5012 40.2326H32.5012V34.5926L37.2712 28.8726ZM32.5012 46.2326H16.5012V42.2326H32.5012V46.2326ZM18.5012 40.2326C18.5012 33.7926 18.5912 33.9726 18.2712 33.5926L13.7612 28.2326L24.5012 12.9626L35.2412 28.2326L30.7312 33.6426C30.4012 34.0326 30.5012 33.9326 30.5012 40.2826L18.5012 40.2326Z",
    fill: "white"
  })))))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_bd_8011_14434",
    x: -107.956,
    y: -95.9416,
    width: 854.912,
    height: 422.912,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 13.3817
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_8011_14434"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4.28214
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 26.2281
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.0283334 0 0 0 0 0.283333 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_backgroundBlur_8011_14434",
    result: "effect2_dropShadow_8011_14434"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_8011_14434",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8011_14434",
    x1: -55.5,
    y1: -57.6741,
    x2: 66.6193,
    y2: 563.818,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_8011_14434",
    x1: -82.1075,
    y1: -75.0106,
    x2: 38.927,
    y2: 454.07,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8011_14434"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 5148,
    fill: "white",
    transform: "translate(-253 -1451)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_8011_14434"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white",
    transform: "translate(0.5 0.232422)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonalize);
export default __webpack_public_path__ + "static/media/personalize.61940a1fdfcea7d23a84324bb6e8133a.svg";
export { ForwardRef as ReactComponent };